'use client';

import { useMemo, useState } from 'react';

import { Container } from '@shared/ui/Container';

import { QuestionCategoryItemType, QuestionItemType } from '../../model/types/faqPageData';
import { QuestionChip } from './QuestionChip/QuestionChip';
import { QuestionItem } from './QuestionItem/QuestionItem';
import cls from './Questions.module.scss';

type QuestionsProps = {
  questions: QuestionCategoryItemType[];
};

const ALL_KEY = 'all';

export const Questions = ({ questions }: QuestionsProps) => {
  const allQuestions = useMemo(() => {
    if (questions && questions.length) {
      return questions.flatMap((category) => category.questions);
    }
    return [];
  }, [questions]);

  const [data, setData] = useState<QuestionItemType[]>(allQuestions);
  const [activeTab, setActiveTab] = useState<string>(ALL_KEY);

  const changeActiveTab = (id: string) => {
    if (id === ALL_KEY) {
      setData(allQuestions);
    } else {
      setData(questions.find((question) => question.id === id)?.questions || []);
    }

    setActiveTab(id);
  };

  return (
    <div className={cls.wrap}>
      <Container>
        <div className={cls.buttons}>
          <QuestionChip
            id={ALL_KEY}
            label={'Все'}
            active={activeTab === ALL_KEY}
            onClick={changeActiveTab}
          />
          {questions.map(({ label, id }) => (
            <QuestionChip
              key={id}
              id={id}
              label={label}
              active={activeTab === id}
              onClick={changeActiveTab}
            />
          ))}
        </div>

        <div className={cls.list}>
          {data
            .filter((el) => el.active)
            .map((item) => (
              <QuestionItem
                key={item.id}
                id={item.id}
                data={item}
              />
            ))}
        </div>
      </Container>
    </div>
  );
};
